/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useEffect, useState, useRef, useCallback } from "react";
import VoiceService from "./VH-Myra-FrontEnd";
import styles from "./MyraAgent.module.css";

/** ---------- Presentational bit (UI-only refresh) ---------- */
function VoiceAgent({ isListening, isAgentSpeaking, isVisible, onMicClick, isVoiceActive, connectionStatus, isFlowStarted }) {
  const [debugText, setDebugText] = React.useState("");
  const [qaSilencePhase, setQaSilencePhase] = React.useState("listening");
  
  let isHelfFlow = VoiceService._currentFlow === "help" || window.currentFlow === "help";

  // Reset thinking state whenever the agent starts speaking
  React.useEffect(() => {
    if (isAgentSpeaking && debugText === "Processing your question…") {
      setDebugText("");
    }
  }, [isAgentSpeaking]);
  
  React.useEffect(() => {
	  const QNA_FLOWS = ["MyraQnAService", "landingPageFlow", "midJourneyFlow", "post_session_qa"];
	  const isQnAFlow = QNA_FLOWS.includes(window.currentFlow);

	  if (!isQnAFlow) return;
	  if (isAgentSpeaking) return;
	  if (!debugText) return;

	  const interval = setInterval(() => {
		const silenceMs = VoiceService.getSilenceDurationMs?.() || 0;
		if (silenceMs < 2000) {
		  setQaSilencePhase("listening");
		} else if (silenceMs < 3000) {
		  setQaSilencePhase("still");
		} else {
		  setQaSilencePhase("thinking");
		}
	  }, 200);

	  return () => clearInterval(interval);
	}, [debugText, isAgentSpeaking]);

	
	React.useEffect(() => {
		if (isAgentSpeaking) {
			setQaSilencePhase("listening");
		}
	}, [isAgentSpeaking]);



  React.useEffect(() => {
    const el = document.getElementById("debugVoice");
    if (!el) return;

    const observer = new MutationObserver(() => {
      setDebugText(el.innerHTML.trim());
    });

    observer.observe(el, { childList: true, subtree: true, characterData: true });

    return () => observer.disconnect();
  }, []);

  if (!window.doMyTest || !isVisible) {
    return <div />;
  }

  // Default = Listening (red mic), Speaking = green mic
  const micClasses = [styles.micButton, isHelfFlow && styles.helpMicButton, !isAgentSpeaking ? styles.micButtonListening : ""].filter(Boolean).join(" ");

  // Show overlay whenever voice is active
  // Show overlay only when voice is active OR connection issues (but not when not initialized)
  const showOverlay = isVoiceActive || (connectionStatus !== "not_initialized" && (connectionStatus === "disconnected" || connectionStatus === "reconnecting" || connectionStatus === "Preparing_Response" || connectionStatus === "Processing_Question"));
  const QNA_FLOWS = ["MyraQnAService", "landingPageFlow", "midJourneyFlow", "post_session_qa"];
  const isQnAFlow = QNA_FLOWS.includes(window.currentFlow);

  console.log("Connection status is : ", connectionStatus);
  console.log("Current flow is : ", window.currentFlow);

  // Text to show in status pill
  let statusText = "";
  const isInitialConnection = !isVisible && !isFlowStarted;
  if (connectionStatus === "not_initialized") {
    statusText = "";
  } else if (connectionStatus === "disconnected") {
    statusText = isInitialConnection ? "Connecting..." : "Connection lost, trying to reconnect…";
  } else if (connectionStatus === "reconnecting") {
    statusText = "Connecting...";
  } else if (isAgentSpeaking) {
    // SPEAKING takes highest priority when agent is actually speaking
    statusText = "Speaking...";
  } else if (connectionStatus === "Processing_Question" && isQnAFlow) {
    // Show preparing only when NOT speaking
    statusText = "Processing your question...";
  } else if (connectionStatus === "Preparing_Response") {
    // Show preparing only when NOT speaking
    statusText = "Preparing our response…";
  } else if (debugText && isQnAFlow && isListening) {
		  if (qaSilencePhase === "listening") {
			statusText = `Listening… "${debugText}"`;
		  } else if (qaSilencePhase === "still") {
			statusText = `Still listening… "${debugText}"`;
		  } else if (qaSilencePhase === "thinking") {
			statusText = `Thinking… "${debugText}"`;
		  }
	}
  else if (debugText) {
    statusText = '"' + debugText + '"';
  } else {
    statusText = isQnAFlow ? "Ask me anything..." : "Listening...";
  }

  if (isHelfFlow && statusText == "Listening...") {
    statusText = "";
  }

  return (
    <>
      <div className={styles.agentContainer}>
        <button title="Activate Voice Assistant" className={micClasses} onClick={onMicClick} type="button">
          <svg className={`${styles.micIcon} ${isHelfFlow && !debugText && styles.helpMicIcon}`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path fillRule="evenodd" d="M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8h-1a6 6 0 11-12 0H3a7.001 7.001 0 006 6.93V17H7a1 1 0 100 2h6a1 1 0 100-2h-2v-2.07z" clipRule="evenodd" />
            {!isVoiceActive && <line x1="4" y1="4" x2="16" y2="16" stroke="currentColor" strokeWidth="2" />}
          </svg>
        </button>

        {!isHelfFlow || debugText || statusText ? (
          <div className={[styles.statusOverlay, isHelfFlow && styles.helpstatusOverlay, showOverlay ? styles.statusOverlayActive : ""].filter(Boolean).join(" ")}>
            <span className={`${styles.voiceStatusContent} ${isHelfFlow && !debugText && styles.helpvoiceStatusContent}`}>
              {statusText} <span id="customTextDebug"></span>
              {debugText === "" && (
                <div className={styles.waveformAnimation} aria-hidden="true">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              )}
            </span>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

/** ---------- Hook that manages VoiceService ---------- */
function useVoiceAgent({ flow = true, initialized = false, flowName = "", isManuallyDisabled = false, isManuallyDisabledRef, isEnabled } = {}) {
  const [isAgentSpeaking, setIsAgentSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [currentFlow, setCurrentFlow] = useState(flowName || "");
  const [connectionStatus, setConnectionStatus] = useState("");
  // useEffect(() => {
  //   const checkConnectionStatus = () => {
  //     if (VoiceService.getConnectionStatus) {
  //       const status = VoiceService.getConnectionStatus();
  //       setConnectionStatus(status);
  //     }
  //   };

  //   // Check status every second
  //   const interval = setInterval(checkConnectionStatus, 1000);

  //   // Also check when connection events might occur
  //   const originalOnConnected = VoiceService._callbacks?.onConnected;
  //   VoiceService._callbacks.onConnected = () => {
  //     setConnectionStatus("connected");
  //     if (originalOnConnected) originalOnConnected();
  //   };

  //   return () => {
  //     clearInterval(interval);
  //     if (originalOnConnected) {
  //       VoiceService._callbacks.onConnected = originalOnConnected;
  //     }
  //   };
  // }, []);
  useEffect(() => {
    const checkConnectionStatus = () => {
      if (VoiceService.getConnectionStatus) {
        const status = VoiceService.getConnectionStatus();
        setConnectionStatus(status);

        // NEW: If disconnected and we should be connected, try to reconnect
        if (status === "disconnected" && !isManuallyDisabledRef.current && isEnabled && navigator.onLine && !VoiceService._intentionalClose) {
          console.log("[AGENT] Detected disconnected state, attempting to reconnect...");

          // Wait a moment before attempting to reconnect
          setTimeout(() => {
            if (VoiceService.forceReconnect) {
              VoiceService.forceReconnect();
            } else {
              // Fallback to initialize if forceReconnect doesn't exist
              VoiceService.initialize();
            }
          }, 2000);
        }
      }
    };

    // Check status more frequently when disconnected
    const checkInterval = connectionStatus === "disconnected" ? 2000 : 5000;
    const interval = setInterval(checkConnectionStatus, checkInterval);

    // Also check when connection events might occur
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      setConnectionStatus("connected");
      if (originalOnConnected) originalOnConnected();
    };

    return () => {
      clearInterval(interval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [connectionStatus, isEnabled, isManuallyDisabledRef]);

  // store previous callbacks so we can restore on unmount
  const prevCallbacks = useRef({
    onAgentSpeechStart: undefined,
    onAgentSpeechEnd: undefined,
    onListeningStart: undefined,
    onListeningStop: undefined,
  });

  const wireCallbacks = useCallback(() => {
    const cb = VoiceService._callbacks || (VoiceService._callbacks = {});
    // keep originals
    prevCallbacks.current = {
      onAgentSpeechStart: cb.onAgentSpeechStart,
      onAgentSpeechEnd: cb.onAgentSpeechEnd,
      onListeningStart: cb.onListeningStart,
      onListeningStop: cb.onListeningStop,
    };

    cb.onAgentSpeechStart = () => {
      setIsAgentSpeaking(true);
    };

    cb.onAgentSpeechEnd = () => {
      setIsAgentSpeaking(false);
    };

    cb.onListeningStart = () => {
      setIsListening(true);
    };

    cb.onListeningStop = () => {
      setIsListening(false);
    };
  }, []);

  const initializeVoice = useCallback(() => {
    wireCallbacks();

    const userName = window.localStorage.getItem("self_name") || "";

    if (initialized) {
      VoiceService.initialize({
        onConnected: () => {
          console.log("Connected voice service...");
          if (flowName) VoiceService.startFlow(flowName, userName);
        },
      });
    } else if (flow && flowName) {
      VoiceService.startFlow(flowName, userName);
    }
  }, [flow, initialized, flowName, wireCallbacks]);

  const startFlow = useCallback(
    (name, callbackEndSay) => {
      // if (VoiceService._resourceManager && VoiceService._resourceManager.monitor?.isRunning) {
      //   VoiceService._resourceManager.stopMonitoring();
      // }
      // if (VoiceService._resourceManager) {
      //   const canvas = document.getElementById("pose-canvas") || document.getElementById("ar-canvas");
      //   if (canvas) {
      //     VoiceService._resourceManager.startMonitoring(canvas);
      //   }
      // }
      VoiceService.stopAllVoiceActivity();
      VoiceService._currentFlow = name;
      let flowToCheck = "personalized";
      if (window.currentFlow === "personalized" && (name === "start_silent" || name === "help")) {
        console.log("[FLOW GUARD] Prevented flow override:", name);
        return;
      }
      const userName = window.localStorage.getItem("self_name") || "";
      window.currentFlow = name;
      setCurrentFlow(name);
      if (isManuallyDisabledRef.current) {
        console.log("Voice agent is manually disabled, not starting flow:", name);
        return;
      }

      if (VoiceService._connected) {
        console.log("Start new flow", name);
        // VoiceService.forceStop();
        if (name) VoiceService.startFlow(name, userName);
        window.currentFlow = name;

        if (callbackEndSay) {
          setTimeout(() => {
            VoiceService._callbacks.onAgentSpeechEndCustom = () => {
              console.log("Called back");

              if (callbackEndSay) {
                callbackEndSay();
              }
              VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
            };
          }, 3000);
        }
      } else {
        wireCallbacks();
        VoiceService.initialize({
          onConnected: () => {
            console.log("Connected voice service...", name);
            if (name) VoiceService.startFlow(name, userName);
            window.currentFlow = name;

            if (callbackEndSay) {
              setTimeout(() => {
                VoiceService._callbacks.onAgentSpeechEndCustom = () => {
                  console.log("Called back");

                  if (callbackEndSay) {
                    callbackEndSay();
                  }
                  VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
                };
              }, 3000);
            }
          },
        });
      }
    },
    [wireCallbacks, isManuallyDisabledRef]
  );

  const sendPostQA = useCallback(
    (sendData) => {
      VoiceService.sendPostQA(sendData);
    },
    [wireCallbacks, isManuallyDisabledRef]
  );

  useEffect(() => {
    return () => {
      if (!VoiceService._callbacks) return;
      VoiceService._callbacks.onAgentSpeechStart = prevCallbacks.current.onAgentSpeechStart;
      VoiceService._callbacks.onAgentSpeechEnd = prevCallbacks.current.onAgentSpeechEnd;
      VoiceService._callbacks.onListeningStart = prevCallbacks.current.onListeningStart;
      VoiceService._callbacks.onListeningStop = prevCallbacks.current.onListeningStop;
    };
  }, []);

  return { isAgentSpeaking, isListening, initializeVoice, startFlow, sendPostQA, connectionStatus };
}

function MyraAgent(props) {
  const [isVisible, setIsVisible] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isManuallyDisabled, setIsManuallyDisabled] = useState(false);
  const isManuallyDisabledRef = useRef(isManuallyDisabled);
  const [isFlowStarted, setIsFlowStarted] = useState(false);

  useEffect(() => {
    isManuallyDisabledRef.current = isManuallyDisabled;
  }, [isManuallyDisabled]);

  const { isAgentSpeaking, isListening, initializeVoice, startFlow, sendPostQA, connectionStatus } = useVoiceAgent({
    flow: true,
    initialized: false,
    flowName: "",
    isManuallyDisabled,
    isManuallyDisabledRef,
    isEnabled,
    ...props,
  });

  const [micPermission, setMicPermission] = useState("prompt");
  const [showMicModal, setShowMicModal] = useState(false);
  const [toggleMic, setToggleMic] = useState(false);
  const [isVoiceActive, setIsVoiceActive] = useState(false);
  const activeFlowRef = useRef("");
  useEffect(() => {
    setIsVoiceActive(isAgentSpeaking || isListening);
  }, [isAgentSpeaking, isListening]);

  const checkMicrophonePermission = () => {
    try {
      if (typeof navigator !== "undefined" && navigator.permissions && navigator.permissions.query) {
        navigator.permissions
          .query({ name: "microphone" })
          .then((permissionStatus) => {
            setMicPermission(permissionStatus.state);
            setShowMicModal(true);
            permissionStatus.onchange = () => {
              setMicPermission(permissionStatus.state);
            };
          })
          .catch(() => {
            // If query fails, fall back to direct request attempt
            fallbackCheckMic();
          });
      } else {
        fallbackCheckMic();
      }
    } catch (error) {
      // Fallback path
      fallbackCheckMic();
    }
  };

  const fallbackCheckMic = () => {
    try {
      if (typeof navigator !== "undefined" && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then((stream) => {
            setMicPermission("granted");
            setShowMicModal(true);
            stream.getTracks().forEach((track) => track.stop());
            setIsEnabled(true);
          })
          .catch(() => setMicPermission("denied"));
      } else {
        setMicPermission("denied");
      }
    } catch {
      setMicPermission("denied");
    }
  };

  const getCurrentMicState = async () => {
    if (typeof navigator !== "undefined" && navigator.permissions && navigator.permissions.query) {
      try {
        const status = await navigator.permissions.query({ name: "microphone" });
        return status.state; // 'granted' | 'denied' | 'prompt'
      } catch {
        return micPermission; // fall back to our cached state
      }
    }
    return micPermission; // Safari/older browsers
  };

  // eslint-disable-next-line
  const handleMicClick = async (silent = false, forceStarting = false) => {
    const userName = window.localStorage.getItem("self_name") || "";
    const newToggleState = forceStarting ? forceStarting : !toggleMic;
    setToggleMic(newToggleState);

    if (newToggleState) {
      // Logic to turn the mic ON
      setIsManuallyDisabled(false); // Clear manual disable state
      const state = await getCurrentMicState();
      if (state === "granted") {
        if (window.videoController) {
          window.videoController.pause();
        }
        initializeVoice();
        if (typeof onMicEnabledRef.current === "function") {
          onMicEnabledRef.current(true);
        }
        setIsEnabled(true);
        if (!silent) {
          setIsVisible(true);
        }
        activeFlowRef.current = VoiceService._currentFlow;

        if (!silent) {
          doSay(`Glad to be back ${userName}`, () => {
            VoiceService.resumeCompletely();
            setIsManuallyDisabled(false);
            const flowToStart = VoiceService._currentFlow;
            if (!isListening) {
              window.debugForce = true;
              VoiceService._callbacks.onListeningStart(); // trigger hook path
            }
            setTimeout(() => {
              startFlow(flowToStart);
            }, 500);
          });
        } else {
          setIsManuallyDisabled(false);
          if (!isListening) {
            window.debugForce = true;
            VoiceService._callbacks.onListeningStart(); // trigger hook path
          }

          if (!forceStarting) {
            setTimeout(() => {
              const flowToStart = VoiceService._currentFlow;
              startFlow(flowToStart);
            }, 500);
          }
        }
      } else {
        setShowMicModal(true);
      }
    } else {
      setIsManuallyDisabled(true); // Set manual disable state
      forceStop();
      VoiceService.stopAgentSpeech();
      if (!silent) {
        setTimeout(() => {
          doSay("I will switch off");
        }, 500);
      }
    }
  };
  const handleHomeScreenMyraClick = useCallback(
    async (silent = false) => {
      console.log("[MyraAgent] handleHomeScreenMyraClick called, silent:", silent);
      if (isVisible && isFlowStarted) {
        console.log("[MyraAgent] Flow already started and bubble visible - ignoring click");
        return false;
      }
      let currentPermission;
      try {
        currentPermission = await getCurrentMicState();
      } catch (error) {
        console.error("[MyraAgent] Error checking permission:", error);
        currentPermission = "prompt";
      }
      console.log("[MyraAgent] Current microphone permission:", currentPermission);

      if (currentPermission === "granted") {
        if (onMicEnabledRef.current) {
          onMicEnabledRef.current = null;
        }
        console.log("[MyraAgent] Permission shows as granted - attempting to start flow");
        return await startMyraFlow(silent);
      }

      // 4. If permission is not granted, trigger the HomeScreen modal via the global callback
      console.log("[MyraAgent] Permission not granted - triggering HomeScreen modal");

      if (window.updateMyRAIsActive) {
        window.updateMyRAIsActive(true);
      }

      // Set the flag that HomeScreen uses to show its modal
      if (window.setIsMicModalActive) {
        window.setIsMicModalActive(true);
      }

      // Store callbacks for modal to use
      window._myraPermissionCallbacks = {
        onGrant: async () => {
          console.log("[MyraAgent] Permission granted via HomeScreen modal - attempting to start flow");
          requestMicrophoneAccess();
        },
        onCancel: () => {
          console.log("[MyraAgent] Permission denied via HomeScreen modal");
          // Notify HomeScreen that MyRA is no longer active
          if (window.updateMyRAIsActive) {
            window.updateMyRAIsActive(false);
          }
        },
      };

      return false;
    },
    [isVisible, isFlowStarted, isListening, startFlow, initializeVoice]
  );

  // Helper function to start the Myra flow
  const startMyraFlow = async (silent = false) => {
    try {
      // Notify HomeScreen that MyRA is active
      if (window.updateMyRAIsActive) {
        window.updateMyRAIsActive(true);
      }

      // Show the bubble
      setIsVisible(true);
      setIsEnabled(true);
      setIsManuallyDisabled(false);
      setIsFlowStarted(true);

      // Set up callbacks
      if (onMicEnabledRef.current) {
        onMicEnabledRef.current(true);
      }

      // Initialize voice if not already initialized
      initializeVoice();

      // Start the flow
      if (!isListening) {
        VoiceService._callbacks.onListeningStart();
      }

      let sessionId = window.trSessionId || localStorage.getItem("trSessionId");
      localStorage.setItem("trSessionId", sessionId);
      VoiceService.updateTouchPointandSessionId("landing", sessionId);

      setTimeout(() => {
        startFlow("landingPageFlow");
      }, 800);

      return true;
    } catch (error) {
      console.error("[MyraAgent] Error starting Myra flow:", error);
      return false;
    }
  };
  const requestMicrophoneAccess = () => {
    const userName = localStorage.getItem("self_name") || "";

    try {
      window.updateTextScreen({ USERNAME: userName, REQUEST_MICROPHONE_GRANTED: true, time: new Date().toISOString() });
      if (typeof window !== "undefined" && window.initFromUserGesture) {
        window.initFromUserGesture();
        console.log("Audio unlocked during mic permission flow");
      }

      if (typeof window !== "undefined" && window.unlockAllVideos) {
        window.unlockAllVideos();
      }

      initializeVoice();

      if (typeof navigator !== "undefined" && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then((stream) => {
            setMicPermission("granted");
            setShowMicModal(false);
            const audioTrack = stream.getAudioTracks()[0];
            if (audioTrack) {
              window.updateTextScreen({
                SELECTED_MICROPHONE: audioTrack.label || "Default Device",
                DEVICE_ID: audioTrack.getSettings().deviceId || "default",
                time: new Date().toISOString(),
                USERNAME: userName,
              });
            }
            stream.getTracks().forEach((track) => track.stop());
            // if (onMicEnabledRef) {
            //   onMicEnabledRef.current();
            // }
            if (typeof onMicEnabledRef.current === "function") {
              onMicEnabledRef.current(true);
            }

            setIsVisible(true);
            setIsEnabled(true);
            setIsManuallyDisabled(false);
            // Update HomeScreen state if callback exists
            if (window.updateMyRAIsActive) {
              window.updateMyRAIsActive(true);
            }
          })
          .catch((err) => {
            setMicPermission("denied");
            console.log("Microphone access denied:", err);
            if (window.updateMyRAIsActive) {
              window.updateMyRAIsActive(false);
            }
          });
      } else {
        setMicPermission("denied");
        window.updateTextScreen({ USERNAME: userName, REQUEST_MICROPHONE_DENIED: true, time: new Date().toISOString() });
        if (window.updateMyRAIsActive) {
          window.updateMyRAIsActive(false);
        }
      }
    } catch (error) {
      setMicPermission("denied");
      window.updateTextScreen({ USERNAME: userName, REQUEST_MICROPHONE_DENIED: true, time: new Date().toISOString() });
      console.log("Microphone access denied:", error);
      if (window.updateMyRAIsActive) {
        window.updateMyRAIsActive(false);
      }
    }
  };

  const handleSkipMicrophone = () => {
    const userName = localStorage.getItem("self_name") || "";
    window.updateTextScreen({ USERNAME: userName, REQUEST_MICROPHONE_DENIED: true, time: new Date().toISOString() });
    setShowMicModal(false);
    if (document.querySelector("#assesmentDiv video")) {
      document.querySelector("#assesmentDiv video").play();
    }
  };

  const MicPermissionModal = ({ requestMicrophoneAccess, onExit }) => {
    const userName = localStorage.getItem("self_name") || "";
    // Check if we're on the home screen
    const isHomeScreen = window.isThisFromHomeScreen === true && !window.forceNotHomeScreen;
    window.updateTextScreen({ USERNAME: userName, REQUEST_MICROPHONE: true, time: new Date().toISOString() });

    if (isHomeScreen) {
      // For home screen, DO NOT render anything here
      // The HomeScreen component handles its own modal (LandingPageModal)
      // Just ensure the callbacks are set up
      if (!window._myraPermissionCallbacks) {
        window._myraPermissionCallbacks = {
          onGrant: () => {
            console.log("[MicPermissionModal] HomeScreen onGrant called");
            // Call the actual request function
            requestMicrophoneAccess();
          },
          onCancel: () => {
            console.log("[MicPermissionModal] HomeScreen onCancel called");
            onExit();
          },
        };
      }

      // Return null - HomeScreen will render its own modal
      return null;
    }

    // For non-home screens, render the original modal
    return renderDefaultModal(requestMicrophoneAccess, onExit);
  };

  // Helper function for the original modal content
  const renderDefaultModal = (requestMicrophoneAccess, onExit) => {
    let messagePopup = !!localStorage.getItem("startedSelf") ? "During your Guided Self-Assessment, you'll perform movement tests away from your camera. We'd like your permission to use your microphone to make communication easier without needing to return to your device. If you allow, Myra, your virtual assistant, will guide you through the process." : "During your Guided Exercise Session, you'll perform exercises away from your camera. We'd like your permission to use your microphone to make communication easier without needing to return to your device. If you allow, Myra, your virtual assistant, will guide you through the process.";

    return (
      <div className={styles.PMcontainer}>
        <div className={styles.PMmodal}>
          <h3 className={styles.PMtitle}>Microphone Permission</h3>
          <p className={styles.PMtext}>
            {messagePopup}
            <br />
          </p>
          <div className={styles.PMactions}>
            <button onClick={onExit} className={styles.PMbuttonSecondary}>
              No Thanks
            </button>
            <button onClick={requestMicrophoneAccess} className={styles.PMbuttonPrimary}>
              Allow Microphone
            </button>
          </div>
          <span className={styles.PMBTMtext}>You can disable the microphone anytime, and your privacy is always respected.</span>
        </div>
      </div>
    );
  };

  const onMicEnabledRef = useRef(null);
  const setOnMicEnabled = useCallback((cb) => {
    onMicEnabledRef.current = typeof cb === "function" ? cb : null;
  }, []);
  // eslint-disable-next-line
  const forceStop = useCallback(() => {
    VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
    VoiceService._stopListening();
    VoiceService.forceStop();
    VoiceService.stopAllVoiceActivity();
    setTimeout(() => {
      VoiceService._stopListening();
    }, 500);
  }, []);

  const doSay = useCallback((text, doCallback) => {
    try {
      const userName = window.localStorage.getItem("self_name") || "";
      console.log("Saying", text, userName);

      if (VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
        VoiceService._ws.send(JSON.stringify({ type: "say", text: text, name: userName }));

        VoiceService._callbacks.onAgentSpeechEndCustom = () => {
          console.log("Called back");

          if (doCallback) {
            doCallback();
          }

          VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
        };

        console.log("Sent speech command to backend");
      } else {
        console.warn("WebSocket not connected - cannot send speech command");
      }
    } catch (error) {
      console.error("Error sending speech command:", error);
    }
  }, []);

  const disableCallback = useCallback(() => {
    try {
      VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
    } catch (error) {
      console.error("Error disabling callback:", error);
    }
  }, []);

  const setupGlobalVirtualListener = useCallback(() => {
    window.startFlowFlutter = (flow, callbackArray, callbackSpeakOver) => {
      VoiceService._currentFlow = flow;

      if (isManuallyDisabledRef.current) {
        console.log("Voice agent is manually disabled, not starting Flutter flow:", flow);
        return;
      }
      // Start Myra flow speaking
      window.mayraCode.startFlow(flow, () => {
        // Call function once speak is completed
        console.log("Called myraCallbackFlutter");
        if (window.myraCallbackFlutter) {
          window.myraCallbackFlutter(callbackSpeakOver);
        }
      });

      // Listen for any commands that were sent and forward to myraResponse function
      window.currentCommandsAudio = {};
      for (let oneItem of callbackArray) {
        window.currentCommandsAudio[oneItem] = (val) => {
          if (window.myraResponse) {
            window.myraResponse(val);
          }
        };
      }
    };

    window.startListenMyra = (listeningFor) => {
      // Check if manually disabled before starting listening
      if (isManuallyDisabledRef.current) {
        console.log("Voice agent is manually disabled, not starting listening for:", listeningFor);
        return;
      }
      console.log("Recevied 1", listeningFor);

      let listenObject = [];
      if (typeof listeningFor == "string" && listeningFor.indexOf("}") > 0) {
        try {
          listenObject = JSON.parse(listeningFor);
          listeningFor = listenObject[0];
        } catch (e) {
          console.error(e);
        }
      }

      console.log("Recevied 2", listenObject);

      if (listeningFor === "demovideo") {
        window.stopAudio();
        window.mayraCode.disableCallback();
        window.mayraCode.setIsVisible(true);
        window.mayraCode.startFlow("start_silent_demo");
        VoiceService._currentFlow = "start_silent_demo";
        window.currentCommandsAudio = {
          SKIP_VIDEO: () => {
            if (window.virtualDemoPlay) {
              window.virtualDemoPlay.pause();
            }
            window.mayraCode.doSay("Got it! Skipping the video.", () => {
              setTimeout(() => {
                if (window.skipDemoVideoMyra) {
                  window.skipDemoVideoMyra();
                }
              }, 2000);
            });
          },

          REPLAY_VIDEO: () => {
            if (window.virtualDemoPlay) {
              window.virtualDemoPlay.pause();
              window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
                window.virtualDemoPlay.seek(0);
                window.virtualDemoPlay.play();
              });
            }
          },

          PAUSE_VIDEO: () => {
            if (window.virtualDemoPlay) {
              window.virtualDemoPlay.pause();
              window.mayraCode.doSay("Sure! I’ll pause the video for you. When you’re ready to continue, just say Myra, resume video.", () => {});
            }
          },

          RESUME_VIDEO: () => {
            if (window.virtualDemoPlay) {
              if (document.querySelector("#player_ondemand video")) {
                if (document.querySelector("#player_ondemand video").paused) {
                  window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
                    window.virtualDemoPlay.play();
                  });
                }
              }
            }
          },
          INVALID_COMMAND: () => {
            if (window.virtualDemoPlay) {
              window.virtualDemoPlay.pause();
              window.mayraCode.doSay("I didn't catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                setTimeout(() => {
                  window.virtualDemoPlay.play();
                }, 400);
              });
            }
          },
          VALID_COMMAND: () => {
            if (window.virtualDemoPlay) {
              window.virtualDemoPlay.pause();
              window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                setTimeout(() => {
                  window.virtualDemoPlay.play();
                }, 400);
              });
            }
          },
        };
      } else if (listeningFor === "notvisible") {
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("notvisible");
        window.currentCommandsAudio = {
          START_HELP: () => {
            if (window.myraResponse) {
              window.myraResponse("START_HELP");
            }
          },
          START_PAUSE: () => {
            if (window.myraResponse) {
              window.myraResponse("START_PAUSE");
            }
          },
        };
      } else if (listeningFor === "help") {
        window.mayraCode.setIsVisible(true);
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("help");
        window.currentCommandsAudio = {
          PAUSE_EXERCISE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("PAUSE_EXERCISE");
            }
          },
          RESUME_EXERCISE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("RESUME_EXERCISE");
            }
          },
          SKIP_EXERCISE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("SKIP_EXERCISE");
            }
          },
          SELECT_ANSWER: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          CONFIRM_START_POSITION: (val) => {
            if (window.myraResponse) {
              window.myraResponse("CONFIRM_START_POSITION");
            }
          },
          SESSION_CHOICE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
        };
      } else if (listeningFor === "endSessionFlow") {
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("endSessionFlow");
        window.currentCommandsAudio = {
          SELECT_ANSWER: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
        };
      } else if (listeningFor === "skippedExerciseFlow") {
        window.mayraCode.disableCallback();
        window.mayraForwardCode = listenObject[1] || {};
        window.mayraCode.startFlow("skippedExerciseFlow");
        window.currentCommandsAudio = {
          SELECT_ANSWER: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SESSION_CHOICE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECTED_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },

          SELECT_LATER: (val) => {
            if (window.myraResponse) {
              window.myraResponse("LATER");
            }
          },
          SELECT_DONT_LIKE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("DONT_LIKE");
            }
          },
          SELECT_HARD: (val) => {
            if (window.myraResponse) {
              window.myraResponse("HARD");
            }
          },
          SESSION_END: (val) => {
            if (window.myraResponse) {
              window.myraResponse("END");
            }
          },
          SESSION_NEXT: (val) => {
            if (window.myraResponse) {
              window.myraResponse("NEXT");
            }
          },
        };
      } else if (listeningFor === "ExerciseCompletedDoneBefore") {
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("ExerciseCompletedDoneBefore");
        window.currentCommandsAudio = {
          SELECT_ANSWER: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SESSION_CHOICE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          EXERCISE_COMPLETED: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_COMPARISON: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECTED_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_SYMPTOM: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
        };
      } else if (listeningFor === "ExerciseCompletedFirstTimeFlow") {
        window.mayraCode.disableCallback();
        window.mayraForwardCode = listenObject[1] || {};
        window.mayraCode.startFlow("ExerciseCompletedFirstTimeFlow");
        window.currentCommandsAudio = {
          SELECT_ANSWER: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SESSION_CHOICE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          EXERCISE_COMPLETED: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_COMPARISON: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECTED_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_SYMPTOM: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
        };
      } else if (listeningFor === "post_session_qa") {
        window.mayraCode.disableCallback();
        window.mayraCode.sendPostQA(listenObject[1] || {});
        window.mayraCode.startFlow("post_session_qa");
        window.currentCommandsAudio = {};
      }
    };
  }, [isManuallyDisabledRef]);

  const api = useMemo(
    () => ({
      startFlow,
      initializeVoice,
      setIsVisible,
      setShowMicModal,
      setOnMicEnabled,
      doSay,
      handleMicClick,
      handleHomeScreenMyraClick,
      forceStop,
      isEnabled,
      isVisible,
      isFlowStarted,
      setIsFlowStarted,
      disableCallback,
      setupGlobalVirtualListener,
      sendPostQA,
      setHelpState: (helpDataArray) => {
        return VoiceService.setHelpState(helpDataArray);
      },
      getState: () => ({
        isAgentSpeaking,
        isListening,
        micPermission,
        showMicModal,
        isManuallyDisabled,
        isManuallyDisabledRef,
      }),
    }),
    [startFlow, initializeVoice, isAgentSpeaking, isListening, micPermission, showMicModal, setIsVisible, setShowMicModal, setOnMicEnabled, doSay, handleMicClick, forceStop, isEnabled, isVisible, disableCallback, setupGlobalVirtualListener, sendPostQA, isManuallyDisabled, isFlowStarted, isManuallyDisabledRef]
  );

  // Hand the API to parent when available; clear on unmount
  useEffect(() => {
    window.mayraCode = api;
    window.startFlow = api.startFlow;
    window.mayraForceStop = () => {
      window.mayraCode.forceStop();
      setIsVisible(false);
      setIsEnabled(false);
    };

    window.doSay = api.doSay;
    window.setHelpState = api.setHelpState;
    window.handleHomeScreenMyraClick = api.handleHomeScreenMyraClick;

    window.stopMyraCommands = () => {
      window.mayraCode.setOnMicEnabled(null);
      window.currentCommandsAudio = {};
      window.mayraCode.disableCallback();
      window.mayraCode.startFlow("start_silent");
    };

    window.getMyraSpeaking = () => {
      return isAgentSpeaking ? "yes" : "no";
    };

    return () => props.onAgentApi?.(null);
  }, [api]);

  return (
    <div>
      <VoiceAgent isAgentSpeaking={isAgentSpeaking} isListening={isListening} onMicClick={handleMicClick} isVisible={isVisible} isVoiceActive={isVoiceActive} connectionStatus={connectionStatus} />
      {showMicModal && <MicPermissionModal requestMicrophoneAccess={requestMicrophoneAccess} onExit={handleSkipMicrophone} />}
    </div>
  );
}

export default MyraAgent;
